import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const animalsIntoProtocol: ImportTypeConfig = {
  type: 'animals_into_protocol',
}
